import { RecommerceAd } from "../types";

type BapSearchExtrasProps = {
	ad: RecommerceAd;
	className?: string;
};

export function AdExtras(props: BapSearchExtrasProps) {
	const { ad, className = "" } = props;

	return (
		<div className={`flex flex-wrap ${className} text-xs`}>
			{ad.extras.slice(0, 2).map((extra) => {
				const value = extra.values?.[0];
				if (!value) {
					return null;
				}
				const label = extra.label ?? extra.id;

				return <span key={extra.id} className="mr-8">{`${label} ${value}`}</span>;
			})}
		</div>
	);
}
